import React from 'react';

export const SvgDefinitions = () => (
    <svg
        display="none"
        width="0"
        height="0"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <defs>
            <symbol id="SVG_ARROW_DOWN_RIGHT__16" viewBox="0 0 16 16">
                <g
                    fill="none"
                    fillRule="evenodd"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M11.733 12.9L15 9.633l-3.267-3.266" />
                    <path d="M15 9.634H1.934A.934.934 0 0 1 1 8.7V3.1" />
                </g>
            </symbol>
        </defs>
    </svg>
);
